import { useParams } from "react-router-dom";
import { IList } from "../../../utils/generalType";
import "../sharedLandingcss/Site.css";
import "../sharedLandingcss/Site_Animate.css";
import PagerHeaderComp from "./PagesHeaderComp";
import { jobs } from "./Services/service.utils";
import { Tag } from "antd";
import PortServiceWorkFlowComp from "./portfolio_Service_workflow";
import JobsCardMini from "./Jobs_Card_Comp_Mini";

const ourJobs: IList[] = jobs;

export const JobDetails = () => {
  const { id } = useParams();
  const selectedIndex = Number(id) < (jobs.length + 1) ? Number(id || 1) - 1 : 0; // Adjusted to use index 0 if out of bounds

  const job = ourJobs[selectedIndex];

  if (!job) {
    return <div className="text-center p-4"> Job Portfolio not found.</div>;
  }

  return (
    <>
      <PagerHeaderComp title={job.title} subTitle={job.subTitle} />

      {/* job Details */}
      <div className="py-12 bg-gray-50">
        <div className="px-4">
          <div className="container mx-auto px-4 py-8">
            <div className="flex flex-col lg:flex-row">
              <div className="w-full px-4 py-2">
                <div className="mb-6 text-center">
                  <img
                    className="rounded-xl mx-auto object-cover w-full h-auto"
                    style={{ maxWidth: "700px" }}
                    src={job.image}
                    alt="job"
                  />
                </div>

                <div className="text-2xl font-semibold mb-6 text-center">
                  {job.caption}
                </div>

                <div className="prose max-w-none text-center mb-6">
                  {job.content}
                </div>

                <div className="mb-6 text-center space-x-2">
                  <span className="text-lg font-semibold text-teal-900">Tag: </span>
                  {job.tag?.map((tag, index) => (
                    <Tag key={index} className="text-md" color="green">
                      {tag}
                    </Tag>
                  ))}
                </div>

                <div className="mb-6 text-center">
                  <a
                    type="primary"
                    href={job.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-full transition"

                  >
                    Visit Site
                  </a>
                </div>

                <JobsCardMini></JobsCardMini>

                {/* Workflow Section */}
                <PortServiceWorkFlowComp></PortServiceWorkFlowComp>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* job Details */}
    </>
  );
};

export default JobDetails;
